import * as actionTypes from "../actions/actionTypes";

const initialState = {
  screenSaverTime: 1,
  startScreen: null,
  deviceFloorLevel: 1
};

const settingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {

    case actionTypes.SET_START_SCREEN:
      return {
        ...state,
        startScreen: payload
      };
    
    case actionTypes.SET_SCREENSAVER_TIME:
      return {
        ...state,
        screenSaverTime: payload
      };

    case actionTypes.SET_DEVICE_FLOOR_LEVEL:
      return {
        ...state,
        deviceFloorLevel: payload
      };

    default:
      return state;
  }
};

export default settingsReducer;
